import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="28" height="28" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.25195 6C4.02351 4.23409 5.78559 3 7.83591 3C9.88623 3 11.6483 4.2341 12.4199 6M13.25 4V7H10.25M12.748 10C11.9765 11.7659 10.2144 13 8.16409 13C6.11377 13 4.35169 11.7659 3.58013 10M2.75 12L2.75 9L5.75 9"
        stroke="#101010"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Svg;
